export default __webpack_public_path__ + "static/media/right-arrow.ef45b4cb.svg";